import { supabase } from './supabaseClient'

export async function updateBodyMetrics(
  userId: string,
  metrics: { height_cm?: number; current_weight_kg?: number },
): Promise<{ error: string | null }> {
  const { error } = await supabase.from('profiles').update(metrics).eq('id', userId)
  return { error: error?.message ?? null }
}

/** Foundation hook for weekly weigh-in check-ins. */
export async function logWeighIn(userId: string, weightKg: number, date = new Date().toISOString().slice(0, 10)): Promise<{ error: string | null }> {
  const { error: weighError } = await supabase.from('weekly_weigh_ins').insert({
    user_id: userId,
    date,
    weight: weightKg,
  })

  if (weighError) return { error: weighError.message }

  const { error: profileError } = await supabase.from('profiles').update({ current_weight_kg: weightKg }).eq('id', userId)
  return { error: profileError?.message ?? null }
}

export async function updateCycleTracking(
  userId: string,
  fields: {
    last_period_start_date?: string | null
    avg_cycle_length?: number
    avg_period_duration?: number
  },
): Promise<{ error: string | null }> {
  const { error } = await supabase.from('profiles').update(fields).eq('id', userId)
  return { error: error?.message ?? null }
}

export async function updateProfilePreferences(
  userId: string,
  fields: {
    weekly_commitment?: number
    meal_frequency?: string
    weekly_budget_value?: number
    preferred_workout_start?: string
  },
): Promise<{ error: string | null }> {
  const { error } = await supabase.from('profiles').update(fields).eq('id', userId)
  return { error: error?.message ?? null }
}
